import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import { Admin, Resource } from "react-admin";
import { FullScreen, useFullScreenHandle } from "react-full-screen";

import AboutShop from "./pages/AboutShop";
import BigSpender from "./pages/business-insight/Report/src/Component/Customer/BigSpender";
import BusinessInsight from "./pages/business-insight/Dashboard/Insight";
import BusinessInsightDashboard from "./pages/business-insight/Dashboard/Dashboard";
import ChangePasswordPage from "./pages/ChangePasswordView";
import { Container } from "@material-ui/core";
import CustomerInsightPage from "./pages/customer-insight/index";
import CustomerInsightPageMemberProfiles from "./pages/customer-insight/members/Profiles";
import CustomerInsightPagePotentialProfiles from "./pages/customer-insight/potential-pages/Profiles";
import CustomerPath from "./pages/business-insight/CustomerPath";
import EarnPoints from "./pages/business-insight/Report/src/Component/Loyalty/EarnPoints";
import ForgotPassword from "./pages/forgot-password/ForgotPassword";
import Frequency from "./pages/business-insight/Report/src/Component/Customer/Frequency";
import GeneralInfoView from "./pages/customer-insight/members/GeneralInfoView";
import InputOTP from "./pages/forgot-password/InputOTP";
import LoyaltyPath from "./pages/business-insight/LoyaltyPath";
import MainMenuPage from "./pages/mainmenu";
import ManagementView from "./pages/management";
import Member from "./pages/business-insight/Report/src/Component/Customer/Member";
import MemberAndWalkIn from "./pages/business-insight/Report/src/Component/Customer/MemberAndWalk-In";
import MemberList from "./pages/customer-insight/MemberList";
import MerchantSetting from "./pages/merchant-setting";
import MerchantSettingView from "./pages/management/merchant-setting/edit";
import PaymentAddProduct from "./pages/payment/payment-addproduct/";
import { PaymentCreateContextProvider } from "./pages/payment/payment-addproduct/PaymentCreateContext";
import PaymentLite from "./pages/payment/payment-lite";
import PaymentMemberMainmenu from "./pages/payment/payment-membermainmenu";
import PaymentMethodPage from "./pages/payment/payment-method/";
import PaymentSearchMember from "./pages/payment/payment-searchmember/";
import PaymentSelectCustomerType from "./pages/payment/payment-select-customer-type";
import PaymentSuccess from "./pages/payment/payment-success";
import PersonaandLifeStyleView from "./pages/customer-insight/members/PersonaandLifeStyleView";
import Playground from "./Playground";
import { PopupProvider } from "react-hook-popup";
import PotentialList from "./pages/customer-insight/PotentialList";
import PotentialRegister from "./pages/customer-insight/potential-pages/PotentailRegister";
import ProductAndCategoryPath from "./pages/business-insight/ProductAndCategoryPath";
import ProfileEdit from "./pages/management/profile-changepassword/edit";
import RankingPath from "./pages/business-insight/RankingPath";
import RedeemPoints from "./pages/business-insight/Report/src/Component/Loyalty/RedeemPoints";
import RegisterPage from "./pages/customers/Register";
import RemainingPoints from "./pages/business-insight/Report/src/Component/Loyalty/RemainingPoints";
import Report from "./pages/business-insight/Report/src/Component/Revenue";
import ResetPassword from "./pages/forgot-password/ResetPassword";
import ResetPasswordSuccessPage from "./pages/forgot-password/ResetPasswordSuccessPage";
import { Resources as ResourceList } from "./providers/wgProviderHelper";
import RevenuePath from "./pages/business-insight/RevenuePath";
import { Route } from "react-router-dom";
import SocialInfoView from "./pages/customer-insight/members/SocialInfoView";
import TagView from "./pages/customer-insight/members/TagView";
import { ThemeProvider } from "@material-ui/core/styles";
import Tiers from "./pages/business-insight/Report/src/Component/Loyalty/Tiers";
import TopBigSpender from "./pages/business-insight/Report/src/Component/Ranking/TopBigSpender";
import TopPaymentMethods from "./pages/business-insight/Report/src/Component/Ranking/TopPaymentMethods";
import TopProduct from "./pages/business-insight/Report/src/Component/Ranking/TopProducts";
import TopProductCategory from "./pages/business-insight/Report/src/Component/Ranking/TopProductCategory";
import TotalPoints from "./pages/business-insight/Report/src/Component/Loyalty/TotalPoints";
import Transaction from "./pages/business-insight/Report/src/Component/Revenue/Transaction";
import Void from "./pages/business-insight/Report/src/Component/Revenue/Void";
import WalkIn from "./pages/business-insight/Report/src/Component/Customer/Walk-In";
import i18nProvider from "./i18n/i18nProvider";
import loginPage from "./pages/login";
import myLayout from "./components/MyLayout";
import myTheme from "./theme";
import wgAuthProvider from "./providers/wgAuthProvider";
import wgProvider from "./providers/wgProvider";

// import Categories from "./pages/business-insight/Report/src/Component/ProductAndCategory/Categories";
// import Subcategories from "./pages/business-insight/Report/src/Component/ProductAndCategory/Subcategories";
// import Products from "./pages/business-insight/Report/src/Component/ProductAndCategory/Products";

// const theme = createMuiTheme({
//   typography: {
//     fontFamily: ["Myriad Pro", "sans-serif"].join(","),
//   },
// });
const App = () => {
  const handle = useFullScreenHandle();

  return (
    <FullScreen handle={handle}>
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "#f4f4f4",
          // backgroundImage: `url(${bgImage})`,
          // backgroundBlendMode: "overlay",
          // backgroundSize: "cover",
          // backgroundPosition: "center",
          // backgroundRepeat: "noRepeat, repeat",
          // backgroundAttachment: "fixed",
        }}
      >
        <ThemeProvider theme={myTheme}>
          <PopupProvider>
            <Container style={{ padding: 0, width: 1024 }}>
              <PaymentCreateContextProvider>
                <Admin
                  title=""
                  theme={myTheme}
                  layout={
                    (props) => myLayout({ ...props, handle: handle }) //Pass fullscreen handle to Layout to AppBar
                  }
                  loginPage={loginPage}
                  authProvider={wgAuthProvider}
                  dataProvider={wgProvider}
                  i18nProvider={i18nProvider}
                  customRoutes={[
                    <Route
                      exact
                      noLayout
                      path="/forgot-password"
                      component={ForgotPassword}
                    />,

                    <Route exact noLayout path="/otp" component={InputOTP} />,
                    <Route
                      exact
                      noLayout
                      path="/reset-password"
                      component={ResetPassword}
                    />,
                    <Route
                      exact
                      noLayout
                      path="/reset-password-success"
                      component={ResetPasswordSuccessPage}
                    />,
                    <Route
                      exact
                      path="/payment"
                      component={PaymentSelectCustomerType}
                    />,
                    <Route
                      exact
                      path="/payment/lite"
                      component={PaymentLite}
                    />,
                    <Route
                      exact
                      path="/payment/addproduct"
                      component={PaymentAddProduct}
                    />,
                    <Route
                      exact
                      path="/payment/search-member"
                      component={PaymentSearchMember}
                    />,
                    <Route
                      exact
                      path="/payment/member-mainmenu"
                      component={PaymentMemberMainmenu}
                    />,
                    <Route
                      exact
                      path="/payment/success"
                      component={PaymentSuccess}
                    />,
                    <Route exact path="/test" component={Playground} />,
                    <Route exact path="/" component={MainMenuPage} />,
                    <Route
                      exact
                      path="/customers/register"
                      component={RegisterPage}
                    />,
                    <Route
                      exact
                      path="/payment/channels"
                      component={PaymentMethodPage}
                    />,

                    <Route
                      exact
                      path="/change-password"
                      component={ChangePasswordPage}
                    />,
                    <Route exact path="/ci" component={CustomerInsightPage} />,
                    <Route
                      exact
                      path="/ci/potential/profiles/:id"
                      component={CustomerInsightPagePotentialProfiles}
                    />,
                    <Route
                      exact
                      path="/ci/member/profiles/:id"
                      component={CustomerInsightPageMemberProfiles}
                    />,
                    <Route
                      exact
                      path="/ci/member/search"
                      component={MemberList}
                    />,
                    <Route
                      exact
                      path="/ci/potential/search"
                      component={PotentialList}
                    />,
                    <Route
                      exact
                      path="/merchant-setting"
                      component={MerchantSetting}
                    />,
                    <Route
                      exact
                      path="/ci/potential/register"
                      component={PotentialRegister}
                    />,
                    <Route
                      exact
                      path="/ci/member/profiles/:id/general"
                      component={GeneralInfoView}
                    />,
                    <Route
                      exact
                      path="/ci/member/profiles/:id/persona"
                      component={PersonaandLifeStyleView}
                    />,
                    <Route
                      exact
                      path="/ci/member/profiles/:id/social"
                      component={SocialInfoView}
                    />,
                    <Route
                      exact
                      path="/ci/member/profiles/:id/tags"
                      component={TagView}
                    />,
                    <Route
                      exact
                      path="/management"
                      component={ManagementView}
                    />,
                    <Route
                      exact
                      path="/management/setting"
                      component={MerchantSettingView}
                    />,
                    <Route
                      exact
                      path="/management/profile"
                      component={ProfileEdit}
                    />,
                    <Route
                      exact
                      path="/bi"
                      component={BusinessInsightDashboard}
                    />,

                    <Route exact path="/bi/revenue" component={RevenuePath} />,
                    <Route
                      exact
                      path="/bi/report/:type/:id"
                      component={Report}
                    />,

                    <Route
                      exact
                      path="/bi/revenue/transaction"
                      component={Transaction}
                    />,
                    <Route exact path="/bi/revenue/void" component={Void} />,
                    <Route exact path="/bi/ranking" component={RankingPath} />,
                    <Route
                      exact
                      path="/bi/ranking/TopPaymentMethods"
                      component={TopPaymentMethods}
                    />,
                    <Route
                      exact
                      path="/bi/ranking/TopProduct"
                      component={TopProduct}
                    />,
                    <Route
                      exact
                      path="/bi/ranking/TopProductCategoryt"
                      component={TopProductCategory}
                    />,
                    <Route
                      exact
                      path="/bi/ranking/TopPaymentMethods"
                      component={TopPaymentMethods}
                    />,
                    <Route
                      exact
                      path="/bi/ranking/TopBigSpender"
                      component={TopBigSpender}
                    />,
                    <Route
                      exact
                      path="/bi/customer"
                      component={CustomerPath}
                    />,
                    <Route
                      exact
                      path="/bi/customer/BigSpender"
                      component={BigSpender}
                    />,
                    <Route
                      exact
                      path="/bi/customer/Frequency"
                      component={Frequency}
                    />,
                    <Route
                      exact
                      path="/bi/customer/Member"
                      component={Member}
                    />,
                    <Route
                      exact
                      path="/bi/customer/MemberAndWalkIn"
                      component={MemberAndWalkIn}
                    />,
                    <Route
                      exact
                      path="/bi/customer/WalkIn"
                      component={WalkIn}
                    />,
                    <Route
                      exact
                      path="/bi/productandCategory"
                      component={ProductAndCategoryPath}
                    />,

                    <Route exact path="/bi/loyalty" component={LoyaltyPath} />,
                    <Route
                      exact
                      path="/bi/loyalty/TotalPoints"
                      component={TotalPoints}
                    />,
                    <Route
                      exact
                      path="/bi/loyalty/EarnPoints"
                      component={EarnPoints}
                    />,
                    <Route
                      exact
                      path="/bi/loyalty/RedeemPoints"
                      component={RedeemPoints}
                    />,
                    <Route
                      exact
                      path="/bi/loyalty/RemainingPoints"
                      component={RemainingPoints}
                    />,
                    <Route exact path="/aboutshop" component={AboutShop} />,
                    <Route exact path="/bi/loyalty/Tiers" component={Tiers} />,
                    <Route exact path="/insight" component={BusinessInsight} />,
                  ]}
                >
                  {ResourceList.map((res, index) => (
                    <Resource
                      key={index}
                      name={res.path}
                      list={res.view ? res.view.list : null}
                      show={res.view ? res.view.show : null}
                      edit={res.view ? res.view.edit : null}
                      create={res.view ? res.view.create : null}
                    />
                  ))}
                </Admin>
              </PaymentCreateContextProvider>
            </Container>
          </PopupProvider>
        </ThemeProvider>
      </div>
    </FullScreen>
  );
};
export default App;
